import { CardContent } from "@mui/material";

import commoncss from "../../myfin_v2/css/common.module.css";

const ExportPages = ({
  checkBoxList = [],
  selectedItems = [],
  setSelectedItems,
}) => {
  const handleCheckboxChange = (value) => {
    setSelectedItems((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const handleSelectAll = (checked) => {
    setSelectedItems(
      checked ? checkBoxList.map((i) => i.value) : []
    );
  };

  const isAllSelected =
    checkBoxList.length > 0 &&
    selectedItems.length === checkBoxList.length;

  return (
    <CardContent>
      {/* HEADER */}
      {/* <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
          padding: "0 10px",
          gap:"20px"
        }}
      > */}
      {/* </div> */}

      <div
        style={{
          display: "grid",
          // gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "12px",
          padding: "12px",
        }}
      >
        <label className="d-flex align-items-center gap-1 cursor-pointer"   style={{ gap: "4px" }}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            className={commoncss.commonCustomCheckbox}
          />
          <span className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs14}`}>
            All Pages
          </span>
        </label>
        
        {checkBoxList.map(({ label, value }) => (
          <label
            key={value}
            className="d-flex align-items-center gap-1 cursor-pointer"
            style={{ gap: "4px" }}
          >
            <input
              type="checkbox"
              checked={selectedItems.includes(value)}
              onChange={() => handleCheckboxChange(value)}
              className={commoncss.commonCustomCheckbox}
            />
            <span
              className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs14}`}
            >
              {label}
            </span>
          </label>
        ))}
      </div>
    </CardContent>
  );
};

export default ExportPages;
